import React from "react";
import { Button } from "@/components/ui/button";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogFooter, DialogDescription } from "@/components/ui/dialog";
import { FileText, Copy, Printer } from "lucide-react";
import { toast } from "sonner";

export const OfferLetterDialog = ({ offerText, onClose }) => {
  const handleCopy = () => {
    navigator.clipboard.writeText(offerText);
    toast.success("Copied to clipboard");
  };

  const handlePrint = () => {
    const w = window.open("", "_blank");
    w.document.write(`<html><head><title>Offer Letter</title><style>body{font-family:Georgia,serif;max-width:700px;margin:40px auto;padding:20px;line-height:1.7;color:#1e293b;font-size:14px}p{margin-bottom:12px}</style></head><body><pre style="white-space:pre-wrap;font-family:Georgia,serif">${offerText}</pre></body></html>`);
    w.document.close();
    w.print();
  };

  return (
    <Dialog open={!!offerText} onOpenChange={(o) => { if (!o) onClose(); }}>
      <DialogContent className="max-w-2xl max-h-[90vh] overflow-y-auto" data-testid="offer-modal">
        <DialogHeader>
          <DialogTitle className="flex items-center gap-2"><FileText className="w-5 h-5 text-blue-500" />Offer Letter</DialogTitle>
          <DialogDescription>Generated offer for the land owner</DialogDescription>
        </DialogHeader>
        <div className="my-4 p-6 rounded-sm bg-white border border-slate-200 shadow-sm">
          <pre className="text-sm text-slate-700 whitespace-pre-wrap leading-relaxed font-[Georgia,serif]" data-testid="offer-text">{offerText}</pre>
        </div>
        <DialogFooter className="gap-2">
          <Button variant="outline" onClick={handleCopy} data-testid="copy-offer-btn"><Copy className="w-4 h-4 mr-2" />Copy</Button>
          <Button variant="outline" onClick={handlePrint} data-testid="print-offer-btn"><Printer className="w-4 h-4 mr-2" />Print</Button>
          <Button onClick={onClose}>Close</Button>
        </DialogFooter>
      </DialogContent>
    </Dialog>
  );
};
